export default class EstatedParcels {
  constructor(obj) {
    if (obj.parcels) {
      this.fips = obj.parcels.fips;
      this.apn = obj.parcels.apn;
      this.apn_original = obj.parcels.apn_original;
      this.apn_unformatted = obj.parcels.apn_unformatted;
      this.apn_previous = obj.parcels.apn_previous;
      this.fips_code = obj.parcels.fips_code;
      this.depth_ft = obj.parcels.depth_ft;
      this.frontage_ft = obj.parcels.frontage_ft;
      this.area_sq_ft = obj.parcels.area_sq_ft;
      this.area_acres = obj.parcels.area_acres;
      this.county_name = obj.parcels.county_name;
      this.county_land_use_code = obj.parcels.county_land_use_code;
      this.county_land_use_description =
        obj.parcels.county_land_use_description;
      this.standardized_land_use_category =
        obj.parcels.standardized_land_use_category;
      this.standardized_land_use_type = obj.parcels.standardized_land_use_type;
      this.location_descriptions = obj.parcels.location_descriptions;
      this.zoning = obj.parcels.zoning;
      this.building_count = obj.parcels.building_count;
      this.tax_account_number = obj.parcels.tax_account_number;
      this.legal_description = obj.parcels.legal_description;
      this.lot_code = obj.parcels.lot_code;
      this.lot_number = obj.parcels.lot_number;
      this.subdivision = obj.parcels.subdivision;
      this.municipality = obj.parcels.municipality;
      this.section_township_range = obj.parcels.section_township_range;
    }
  }
}
